export const validateIncreasingNumbers = (jsonArray) => {
    try {
        // 确保输入是数组并且不为空
        if (!Array.isArray(jsonArray) || jsonArray.length === 0) {
            throw new Error('Input is not a non-empty array.');
        }

        // 检查数组中的每个对象是否有数值属性
        // 并且该属性是数值，不是NaN
        const numbers = jsonArray.map(obj => {
            const num = Number(obj.startEpNumber);
            if (isNaN(num)) {
                throw new Error('Object does not have a valid numeric value.');
            }
            return num;
        });

        // 使用Array.prototype.every检查数值是否递增
        const isIncreasing = numbers.every((num, index) => index === 0 || num > numbers[index - 1]);
        if (!isIncreasing) {
            throw new Error('Numbers are not increasing.');
        }
        return true;
    } catch (error) {
        return false;
    }
}
export default validateIncreasingNumbers;